import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { UserService } from '../../../services/core.user.service';
import { UiService } from '../../../services/core.ui.service';
import { GfTranslateService } from '../../../services/core.translate.service';

@Component({
  selector: 'ssh-keys-view',
  template: require('./user.ssh-keys.component.html')
})
export class SshKeysViewComponent implements OnInit {
  @Input() user: any;

  sshKeyToAdd: string = '';
  keys: string[] = [];
  supportedKeys: any = false;
  supportedKeysOpen: boolean = false;

  constructor(
    private userService: UserService,
    private uiService: UiService,
    private translateService: GfTranslateService
  ) {}

  ngOnInit() {
    this.userService.authorizedKeys.get(this.user.unixName)
    .then((response: any) => {
      if (_.get(response, 'data.items.authorized_keys', false) !== false) {
        this.keys = _.get(response, 'data.items.authorized_keys', '').split('\n');
      } else {
        this.keys = [];
      }
    }, (response: any) => {
      this.uiService.message.showError(
        this.translateService.translate(response.message.description),
        this.translateService.translate(response.message.title)
      );
      this.keys = [];
    });

    this.userService.supportedKeys.get(this.user.unixName)
    .then((response: any) => {
      this.supportedKeys = response?.response?.items?.keys;
    });
  }

  addKey() {
    if (_.findIndex(this.keys, (n: string) => this.sshKeyToAdd.trim() === n) !== -1) {
      this.uiService.message.showError('That key is already in the list', 'SSH Keys');
      return;
    }
    if (this.sshKeyToAdd.trim().length > 0) {
      if (!Array.isArray(this.keys)) {
        this.keys = [];
      }
      const payload = _.cloneDeep(this.keys);
      payload.push(this.sshKeyToAdd);

      this.userService.authorizedKeys.post(this.user.unixName, payload.join('\n').trim())
        .then((response: any) => {
          if (response.success) {
            this.keys.push(this.sshKeyToAdd);
            this.sshKeyToAdd = '';
            this.uiService.message.showSuccess('Your key was added successfully', 'SSH Keys');
          } else {
            const key_type = _.get(response, 'response.error[0].invalid_type', null);
            if (key_type) {
              this.uiService.message.showError(`The type ${key_type} is not supported!`, 'SSH Keys');
            } else {
              this.uiService.message.showError('Operation failed, please contact system administrator', 'SSH Keys');
            }
          }
        });
    }
  }

  removeKey(key: string) {
    const filtered = _.without(this.keys, key);
    let promise;
    if (filtered.length === 0) {
      promise = this.userService.authorizedKeys.delete(this.user.unixName);
    } else {
      promise = this.userService.authorizedKeys.post(this.user.unixName, filtered.join('\n'));
    }
    promise.then((response: any) => {
      if (response.success) {
        this.uiService.message.showSuccess('The key was removed', 'SSH Keys');
        this.keys = filtered;
      } else {
        this.uiService.message.showError('Could not remove that key', 'SSH Keys');
      }
    });
  }
}
